import { Currency, IsoLocale } from '@izettle/constants';
import { createFormatHelpers } from '../../../schema/common/format';
// Although the locale svFI is also supported, there doesn't seem to be difference between them in terms of formatting
// Hence, in the first step the locale is being directly defined as fiFi. If needed, we can add the dependency on the locale later on
export const locale = IsoLocale.fiFI;
export const currency = Currency.EUR;
export const { formatCurrencyRange, formatPercentRange } = createFormatHelpers(locale, currency);
